export const paths = {
  session: '/iphone_spa/webclip/session',
};
